import styled from '@themes/theme'

export const UserItemRootWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 71%;
  height: auto;
  max-height: calc(100% - 40px);
  margin: 0 auto;
  overflow-y: scroll;
  text-align: left;
  &.pc {
    max-height: calc(100% - 25px);
  }
  .check-box {
    z-index: 1;
    position: relative;
    width: 100px;
    height: 128px;
    margin-top: 25px;
    .ant-checkbox {
      display:none;
      & + span {
        padding-right: 0;
        padding-left: 0;
      }
    }
    .skin-info {
      opacity: .5;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      .skin-img-wrap {
        position: relative;
        background: ${props => props.theme.color.themeTxt};
        border: 1px solid ${props => props.theme.color.mainBg};
        border-radius: 50%;
        overflow: hidden;
        .skin-img {
          width: 100%;
        }
      }
      .skin-quantity {
        position:absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: ${props => props.theme.font.large};
        color: ${props => props.theme.color.mainBg};
        background: ${props => props.theme.color.disableTxt};
        border-radius: 50%;
      }
      .skin-name {
        margin-top: 10px;
        color: ${props => props.theme.color.modalBg};
        text-align: center;
      }
    }
    &.ant-checkbox-wrapper + .ant-checkbox-wrapper {
      margin-left: 0;
    }

    // check
    .ant-checkbox-checked + span  {
      .skin-info {
        opacity: 1;
        .skin-img-wrap  {
          border-color: ${props => props.theme.color.underover};
        }
        .skin-quantity {
          background: ${props => props.theme.color.underover};
        }
      }
    }
  }
`
